import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner.service';
import { configuration } from '../configration';

const AUTH = configuration.AUTH_KEY;

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private spinner: SpinnerService,
    private toaster: ToastrService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        this.spinner.hide();

        if (err.status === 401) {
          localStorage.clear();
          location.reload();
        } else if (err.status === 403) {
          this.toaster.error(err.error.status.description);
          localStorage.removeItem(AUTH); //* [AV] - Redirect to login on getting "ROLE_NOT_ALLOWED" error
          document.location.reload();
          return throwError(() => new Error(err));
        }
        return throwError(() => new Error(err));
      }),
    );
  }
}
